import ResearchFiltering from 'src/javascripts/components/ResearchFiltering';
import {filterTypeahead} from 'src/javascripts/components/typeaheads/TypeaheadBloodhounds';
import {genericDisplayTemplate, logoTemplate} from 'src/javascripts/components/typeaheads/TypeaheadTemplates';
import Table from 'src/javascripts/components/Table';
import AddRowClickLinks from 'src/javascripts/components/tables/AddRowClickLinks';
import ClimateHazardsChart from 'src/javascripts/components/charts/ClimateHazardsChart';
import ClimateRiskTimeseriesChart from 'src/javascripts/components/charts/ClimateRiskTimeseriesChart';
import ImpactDistByAllFrameworksChart from 'src/javascripts/components/charts/ImpactDistByAllFrameworksChart';
import DistributionChart from 'src/javascripts/components/charts/DistributionChart';
import Spinner from 'src/javascripts/components/utilities/Spinner';
import Swal from 'sweetalert2';
import DonutChart from 'src/javascripts/components/charts/DonutChart';
import TrendChart from 'src/javascripts/components/charts/TrendChart';
import TrendRatings from 'src/javascripts/components/charts/TrendRatings';
import RatingBellCurveChart from 'src/javascripts/components/charts/RatingBellCurveChart';
import ToggleReturnsChart from 'src/javascripts/components/charts/actions/ToggleReturnsChart';
import ReturnsChart from 'src/javascripts/components/charts/ReturnsChart';
import ReturnsDollarsChart from 'src/javascripts/components/charts/ReturnsDollarsChart';
import RenderContainer from 'src/javascripts/components/Dashboards/RenderContainer';
import RenderParams from 'src/javascripts/components/Dashboards/RenderParams';

export default function() {
  const accountUrl = $('body').attr('data-account-url');

  // Ease in top image if present
  if ($('.bg-image-top').hasClass('opaque')) {
    $('.bg-image-top, .bg-image-prev').toggleClass('opaque');
  }

  // Iterate through rendering containers
  $('.rendering-container').each(function() {

    // Set element
    let el = $(this);

    // Render container
    RenderContainer(el);

  })
  
  // Update rendering container
  $('.update-rendering').click(function() {
    let el = $(this).closest('.Card').find('.rendering-container');
    let attr = $(this).attr('data-attr');
    let val = $(this).attr('data-value');

    // Update label
    let label = $(this).closest('.dropdown').find('.left .label');
    let text = $(this).text();
    if (typeof label !== 'undefined') { label.empty().append(text) }

    // Spinner
    Spinner(el);

    // Render container
    el.attr('data-' + attr, val);
    RenderContainer(el);

  })

  // Distribution chart
  let hasDist = $('.distributionChart').length !== 0
  let c3NotLoaded = typeof $('.distributionChart').data('c3-chart') === 'undefined';
  if ((hasDist) && (c3NotLoaded)) {
    $('.distributionChart').each(function() {
      let $el = $(this);
      let $chart = new DistributionChart($el);
      $.when( $chart.getData() )
       .then( data => $chart.render(data) );
    })
  }

  // Change footnotes to numbered in order they appear
  $('.section-footnote').each(function(index) {
    $(this).empty().append(index + 1);
  });

  // Material risk topics
  $('.material-only').change(function() {
    let el = $(this).closest('.Card').find('.rendering-container');
    let key = el.attr('data-key');
    let url = '/' + accountUrl + '/sections/renderings/' + key;
    let params = RenderParams(el);
    if (this.checked) {
      params['material'] = 'true';
    } else {
      params['material'] = 'false';
    }

    // Run ajax call
    $.ajax({
      type: "GET",
      dataType: "script",
      url: url + '.js?' + $.param(params)
    });
    $(document).on("turbo:before-cache", function() { el.empty() })

  });

  // Client rating bell curve chart
  if ( ($('.rating-bell-curve-chart').length !== 0) ) {
    if (typeof $('.rating-bell-curve-chart').data('c3-chart') === 'undefined') {
      let chart = new RatingBellCurveChart( $('.rating-bell-curve-chart') );
      chart.render();
    }
  }

  // Questions and portfolio investments search
  filterTypeahead('#investments_search', 'portfolio_investments', '/' + accountUrl + '/portfolios/investments?', 382, 'generic');
  filterTypeahead('.users-search', 'users', '/' + accountUrl + '/users?', 282, 'generic');
  filterTypeahead('#surveys_search', 'surveys_search', '/' + accountUrl + '/surveys?', 282, 'generic');

  // On selecting a user
  $('.users-search').bind('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
    let url = $(location).attr("pathname");
    let params = {};
    let existingUserIds = $('#survey_responses_table').attr('data-user-id');
    let uids = suggestion.value;
    if (typeof existingUserIds !== 'undefined') {uids = uids + ',' + existingUserIds;}
    params['survey_user_id'] = uids;
    params['section_id'] = $('#survey_responses_table').attr('data-section-id');
    params['status'] = $('#survey_responses_table').attr('data-status');
    params['deadline'] = $('#survey_responses_table').attr('data-deadline');
    params['survey_id'] = $('#survey_responses_table').attr('data-survey-id');
    Turbo.visit(url + '?' + $.param(params));
  })

  // On selecting a response
  $('#investments_search').bind('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
    let url = $(location).attr("pathname");
    let params = {};
    let existingSectionIds = $('#survey_responses_table').attr('data-section-id');
    let iids = suggestion.value;
    if (typeof existingSectionIds !== 'undefined') {iids = iids + ',' + existingSectionIds;}
    params['investment_id'] = iids;
    params['status'] = $('#survey_responses_table').attr('data-status');
    params['survey_id'] = $('#survey_responses_table').attr('data-survey-id');
    params['deadline'] = $('#survey_responses_table').attr('data-deadline');
    let userId = $('#survey_responses_table').attr('data-user-id');
    if (typeof userId === 'undefined') {
      params['survey_user_id'] = 'all';
    } else {
      params['survey_user_id'] = userId;
    }
    Turbo.visit(url + '?' + $.param(params));
  })

  // On selecting a survey
  $('#surveys_search').bind('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
    let url = $(location).attr("pathname");
    let params = {};
    let existingSurveyIds = $('#survey_responses_table').attr('data-survey-id');
    let iids = suggestion.value;
    if (typeof existingSurveyIds !== 'undefined') {iids = iids + ',' + existingSurveyIds;}
    params['survey_id'] = iids;
    params['investment_id'] = $('#survey_responses_table').attr('data-investment-id');
    params['status'] = $('#survey_responses_table').attr('data-status');
    params['deadline'] = $('#survey_responses_table').attr('data-deadline');
    let userId = $('#survey_responses_table').attr('data-user-id');
    if (typeof userId === 'undefined') {
      params['survey_user_id'] = 'all';
    } else {
      params['survey_user_id'] = userId;
    }
    Turbo.visit(url + '?' + $.param(params));
  })

  // Survey responses table
  if ( $('#survey_responses_table_wrapper').length === 0 ) {
    let table = new Table($('#survey_responses_table'));
    $.when( table.render() ).then( status => table.setUp('survey_responses_table') )

  }

}